import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { OrgTreeActionsDirective } from '@app/main/org-tree/directives/org-tree-actions.directive';
import { OrgTreeService } from '@app/main/org-tree/services/org-tree.service';
import { Subscription } from 'rxjs';
import { MatDrawer } from '@angular/material/sidenav';
import { ModuleService } from '@shared/services/module.service';

@Component({
    selector: 'app-org-drawer',
    templateUrl: './org-drawer.component.html',
    styleUrls: ['./org-drawer.component.scss'],
    standalone: false
})
export class OrgDrawerComponent extends OrgTreeActionsDirective implements OnInit, OnDestroy {
    @ViewChild('drawer', { static: true }) drawer: MatDrawer;
    subscription: Subscription;
    responsible: string;
    specialists: string;

    constructor(orgTreeService: OrgTreeService, moduleService: ModuleService) {
        super(orgTreeService, moduleService);
    }

    ngOnInit(): void {
        this.subscription = this.orgTreeService.toggleDrawer.subscribe(e => {
            if (e) {
                this.drawer.toggle(e?.isOpen);

                if (e.isOpen) {
                    this.setValues();
                }
            }
        });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    setValues() {
        if (this.selectedItem) {
            this.responsible = this.selectedItem?.responsible?.map(e => e.fullName)?.join(', ');
            this.specialists = this.selectedItem?.specialists?.map(e => e.fullName)?.join(', ');
        }
    }
}
